module.exports = __webpack_public_path__ + "img/opinions.41464879.svg";